/**
 * Operator Dashboard Help Content
 *
 * Feature: 177 - Dashboard Polish & Collection Column Coverage (US1)
 * Page: /dashboard (Operator role variant)
 * Constitution: v1.22.0 — Principle XXXVII (Code Header Standards)
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const operatorDashboardHelp: PageHelpContent = {
  pageTitle: 'Operator Dashboard',
  purpose:
    'Your operational view of the Fabric Control Plane: collection tier health, capacity utilization, running jobs, and live system status.',
  sections: [
    {
      title: 'What this view shows',
      paragraphs: [
        'The Operator dashboard focuses on day-to-day platform operations. It surfaces how the collection tiers are performing, current capacity CU usage, jobs in flight, and the health of the core services the platform depends on.',
      ],
      concepts: [
        { term: 'Collection Health', definition: 'Per-tier last-run status (Completed / Partial / Failed / Running) with a repeat-failure count so you can spot a tier that keeps failing, not just its most recent run.' },
        { term: 'CU Fleet', definition: 'Capacity-unit utilization across your F-SKU capacities — average and peak usage, throttling windows, and capacities running above 80%.' },
        { term: 'Running Jobs', definition: 'Collection and backup executions currently in progress, with the tier and start time.' },
        { term: 'System Health', definition: 'Reachability + latency of the database, Key Vault, and Fabric API, powered by the 5-minute heartbeat tier.' },
      ],
    },
    {
      title: 'Collection Health — consecutive failures',
      paragraphs: [
        'Each tier row shows its most recent completed run. When a tier has failed repeatedly, a "N consecutive" badge appears: N counts the consecutive Failed or Partial runs back from the newest completed run. In-progress (Running) runs are skipped, so a fresh run does not reset the count. Investigate any tier showing a growing consecutive-failure count.',
      ],
    },
    {
      title: 'Data Refresh',
      paragraphs: [
        'Dashboard data refreshes automatically (polling, ~30s). System Health reflects the latest heartbeat; if it is stale, run the 5-minute tier.',
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Jobs', href: '/jobs' },
        { label: 'Capacity Metrics', href: '/capacity-metrics' },
        { label: 'System Alerts', href: '/alerts' },
        { label: 'Infrastructure Health', href: '/monitoring/health' },
      ],
    },
  ],
};

export default operatorDashboardHelp;
